module.exports = __webpack_public_path__ + "img/pr-11.a007e255.png";